import { API_CALC_URL } from '../../urls';

export const API_SHARE_URL = `${API_CALC_URL}/share-calc`;

export const API_SHARE_LIST_GET_URL = `${API_SHARE_URL}/list`;
export const API_SHARE_ADD_URL = `${API_SHARE_URL}/add`;
export const API_SHARE_DELETE_URL = `${API_SHARE_URL}/del`;
export const API_SHARE_GET_URL = `${API_SHARE_URL}/get`;
export const API_SHARE_ANSWER_STATE_SET_URL = `${API_SHARE_URL}/answer/state/set`;

export const API_SHARE_APPROVE_URL = `${API_SHARE_URL}/approve`;
export const API_SHARE_UNAPPROVE_URL = `${API_SHARE_URL}/unapprove`;
